var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ExternalLinkIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 48,
    glyphHeight: 48
  }), React.createElement("path", {
    d: "M12 7.5C9.51472 7.5 7.5 9.51472 7.5 12V36C7.5 38.4853 9.51472 40.5 12 40.5H36C38.4853 40.5 40.5 38.4853 40.5 36V28.9412C40.5 27.0082 42.067 25.4412 44 25.4412C45.933 25.4412 47.5 27.0082 47.5 28.9412V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5H19.0588C20.9918 0.5 22.5588 2.067 22.5588 4C22.5588 5.933 20.9918 7.5 19.0588 7.5H12Z"
  }), React.createElement("path", {
    d: "M44 21.6177C42.067 21.6177 40.5 20.0507 40.5 18.1177L40.5 7.50003L29.8824 7.50003C27.9494 7.50003 26.3824 5.93302 26.3824 4.00003C26.3824 2.06703 27.9494 0.500027 29.8824 0.500027L43 0.500028C45.4853 0.500028 47.5 2.51475 47.5 5.00003L47.5 18.1177C47.5 20.0507 45.933 21.6177 44 21.6177Z"
  }), React.createElement("path", {
    d: "M16.5252 31.4749C15.1583 30.108 15.1583 27.892 16.5252 26.5251L38.2899 4.76042C39.6567 3.39358 41.8728 3.39359 43.2396 4.76042C44.6065 6.12726 44.6065 8.34333 43.2396 9.71017L21.4749 31.4749C20.1081 32.8417 17.892 32.8417 16.5252 31.4749Z"
  }));
};
export var ExternalLinkIconGlyph = function (props) {
  return React.createElement(ExternalLinkIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};